var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_14_24)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_14_24",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_14_24",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_14_24",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADAUlEQVR4nO3dT6ilcxzH8cf/GH9GI/mXopSNUrKwmJospAizsZ3trG2sFDs2LJSFDSsWFibFQpMUxYKaGqJ0508NIZKQCC893XMzjt+Ze65zzn2+55zPq87mdJ/n+f2+7zo957mL03URscLwML4dvR4aej1rD1/6x5m1H8jQjBl6PWtPgtQiQWqRILVIkFokSC0SpBYJUosEqUWC1CJBapEgtUiQWiRILRKkFglSiwSpRYLUIkFqkSC1SJBaJEgtEqQWCVKLBKlFgtQiQWqRILVIkFokSC0SpBYJUosEqUWC1CJBapEgtUiQWiRILRKkFglSiwSpRYLUIkFqkSC1SJBaJEgtEqQWCVKLBKlFgtQiQWqRILVIkFokSC0SpBYJUosEqUWC1CJBapEgtUiQWiRILRKkFglSiwSpRYLUIkFqkSC1SJBaJMjMA3wU3+ErPFItiM3fRdzASdzfrTKcN4qx5Q8cqhIEh0Zr2nKqW3X4ZmyGf+Lw0EFweLSWs210q67/mMLvYxv/C48NFaS/9mgNZ+vX+GC3DvAAfh0fJp7e7SB4vLGO33CwWyc4gJ8aw3hmt4Lgqcb1f8F93TrCfvzYGMoLOH9RQUY3F881rvsz7u3WGe4au/Pa8uI0UYyZMsbz48fhB9wzt40tM9w5+j30ca/iwm2O/Zdt/vYCvPyfq/A97p77xpYZbu9/D70xrDdwyaxBcDFea5z/a9yxsI0tM9yCE42hvYVL/2+QPiiONM57GrctfGPLDDfji8bw3sUVOw2Cy/B243z9o5Fbd21jywzX4XhjiO/jqmmD4HK80zjPZ7hx1ze2zHAtjjWG+TGu2S4IrsaHjeM/xfWDbWyZYS8+mDDUGyYFOUfMj7Bv6H0tNZM/dj7HTY33+4+7Txrvv4crh97PSsAeHG0MeWPK9/pj9wy9j5Vi89b1dTv35qRb5pg9ykUTvtxNcs4vlTEHNh9/vDRFjFe2e+wSc2LyA8IdPZiM+Ud5dpZH97EAeHKW/zjGAuCJ/pXhRnQr7m8huxtB4SkGUwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon-arrow-down.73abd81459d0d787d35964be68b5ef73.svg";
export { ForwardRef as ReactComponent };